angular.module('picmonicng').controller('ReferralsController', [
  '$rootScope',
  '$scope',
  '$stateParams',
  'UserService',
  'User',
  '$filter',
  'toaster',
  '$http',
  '$anchorScroll',
  function ($rootScope, $scope, $stateParams, UserService, User, $filter, toaster, $http, $anchorScroll) {
    //const promotionalFrom = new Date(1667991540000);
    const promotionalFrom = new Date(1567991540000);
    const promotionalTo = new Date(1669967940000);
    const now = new Date().getTime();
    const amazonGiftCardAmount = '$5';
    const promoAmazonGiftCardAmount = '<del>$5</del> $10';
    $scope.now = now;

    $scope.base_asset_url = $rootScope.base_asset_url;
    $scope.UserService = UserService;
    $scope.redeem_email = UserService.user.email;
    $scope.userAgent = navigator.userAgent;
    $scope.isAdmin = !!$stateParams.is_admin;
    $scope.showPromotional = now >= promotionalFrom && now <= promotionalTo;

    $scope.navItemSelected = 'sharelink';
    $scope.navItems = [
      { id: 'sharelink', name: 'Share Your Link' },
      { id: 'howitworks', name: 'How It Works' },
      { id: 'yourstats', name: 'Your Stats' },
      { id: 'yourreferralhistory', name: 'Your Referral History' },
      { id: 'extrabonuses', name: 'Extra Bonuses' },
      { id: 'itseasytogetstarted', name: 'Get Started' },
      { id: 'downloadableresources', name: 'Downloadable Resources' },
      { id: 'hashtaglibrary', name: 'Hashtag Library' },
      { id: 'talkingpoints', name: 'Talking Points' },
      { id: 'learnmoreaboutpicmonic', name: 'Learn More About Picmonic' },
      { id: 'gethelp', name: 'Get Help' },
    ];

    $scope.redeemRewards = function () {
      if (
        $scope.referrals.total_redeemable_balance &&
        !$scope.loading_redeem &&
        confirm('Are you sure you want to request your rewards be sent to ' + $scope.redeem_email + '?')
      ) {
        $scope.loading_redeem = true;
        User.post(
          {
            resource: 'referrals',
            resource_id: 'redeem',
            email: $scope.redeem_email,
          },
          function () {
            $scope.referrals = User.get({ resource: 'referrals' });
            $scope.referrals.$promise.then(function () {
              toaster.success('Reward successfully requested! Check your inbox within 24 hours.');
              $scope.loading_redeem = false;
            });
          },
          function (response) {
            $scope.loading_redeem = false;
            toaster.error(response.data.message);
          }
        );
      }
    };

    if ($scope.isAdmin) {
      $scope.referrals = {};
      $http.get('/api/v3/admin/users/' + $stateParams.id + '/referrals').then(function (referrals) {
        $scope.referralsLimit = null;
        $scope.referrals = referrals.data;
        $scope.$emit('endInteraction');
      });
    } else {
      $scope.referrals = User.get({ resource: 'referrals' });
      $scope.referrals.$promise.then(function (referrals) {
        $scope.$emit('endInteraction');
      });
    }

    $anchorScroll.yOffset = 16;

    $scope.selectAnchor = function (anchor) {
      $scope.navItemSelected = anchor;
      $anchorScroll(anchor);
    };

    /**
     * Retrieves the Amazon Gift Card dollar amount
     */
    $scope.getAmazonGiftCardAmount = function () {
      if ($scope.showPromotional) {
        return promoAmazonGiftCardAmount;
      }

      return amazonGiftCardAmount;
    };
  },
]);
